import { repo } from '../utils/domain-handler/actions/repo'

export class ControllerBase {
    app;
    repo = repo;
    actions;
    loading = false;
    showDialog = false

    // MODULES
    auth = null;
    crud = null;

    constructor(options = baseParams) {
        installModules(this, options);
    }

    setApp(app) {
        this.app = app;
        this.initialise();
    }

    initialise() {
        this.onReady();
    }

    onReady() {
    }
}

function installModules(ctrl, options) {
    for (var module in baseParams.modules) {
        if (options.required_modules[module]) {
            let moduleToInstall = options.modules[module];

            if (moduleToInstall == undefined || moduleToInstall == null) {
                throw "please provide module: " + module;
            }
            else {
                ctrl[module] = moduleToInstall;
            }
        }
    }
}

export const modules = {
    auth: null,
    crud: null,
    logger: null,
    error_handler: null,
    translation: null
}

export function ModuleBuilder(params = modules) {
    return {
        auth: params.auth,
        crud: params.crud,
        error_handler: params.error_handler,
        logger: params.logger,
        translation: params.translation
    }
}

const baseParams = {
    globalInstance: Boolean,
    modules: {
        ...modules,
    },
    required_modules: {
        auth: false,
        crud: null,
        error_handler: false,
        logger: false,
        translation: false
    }
}